import { render } from "./JMessageArticlePanelBody.vue?vue&type=template&id=f83e57f0&scoped=true&ts=true"
import script from "./JMessageArticlePanelBody.vue?vue&type=script&lang=ts"
export * from "./JMessageArticlePanelBody.vue?vue&type=script&lang=ts"

import "./JMessageArticlePanelBody.vue?vue&type=style&index=0&id=f83e57f0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f83e57f0"]])

export default __exports__